/* Exos 2026-10-18: "Add a half piece?" on door stop product pages (snippets/door-stop-half-piece.liquid).
   No:  nothing changes, the theme's own add to cart runs.
   Yes: one /cart/add.js call with two lines, the door stop (qty as chosen) and its matching half piece (qty 1),
        linked by _Door Config ID so assets/door-addon-cart-sync.js keeps the half at 1 and removes it with its door
        stop (_Door Add-On Fixed Qty). The Add to Cart price shows door stop x qty + the half while Yes is picked.
   The block is hidden until this script runs, so a failed script means no toggle, never a silently dropped half. */
(function () {
  "use strict";

  function money(cents) {
    var t = window.theme;
    if (t && typeof t.formatMoney === "function" && t.moneyFormat) {
      if (t.settings && t.settings.currency_code_enable && t.moneyWithCurrencyFormat) return t.formatMoney(cents, t.moneyWithCurrencyFormat);
      return t.formatMoney(cents, t.moneyFormat);
    }
    return "$" + (cents / 100).toFixed(2);
  }
  var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };

  function init(root) {
    if (!root || root.__exosHalf) return;
    var formId = root.getAttribute("data-form-id");
    var mapEl = root.querySelector("[data-half-map]");
    var map = {};
    try { map = JSON.parse(mapEl ? mapEl.textContent : "{}") || {}; } catch (e) { map = {}; }
    if (!formId || !Object.keys(map).length) return;
    root.__exosHalf = true;

    var scope = root.closest("product-info") || root.closest("[data-product-block]") || root.closest("product-form") || document;
    var yesBtn = root.querySelector('[data-half-choice="yes"]');
    var noBtn = root.querySelector('[data-half-choice="no"]');
    var priceEl = root.querySelector("[data-half-price]");
    var state = { yes: false, busy: false };

    function form() { return document.getElementById(formId); }
    function variantId() { var f = form(); var i = f && f.querySelector('input[name="id"]'); return i ? String(i.value) : ""; }
    function entry() { return map[variantId()] || null; }
    function qtyField() { return scope.querySelector("[data-quantity-field]") || document.querySelector('input[name="quantity"][form="' + formId + '"]'); }
    function qty() { var f = qtyField(); var n = parseInt(f && f.value, 10); return n > 0 ? n : 1; }
    function button() { var f = form(); return f ? f.querySelector('button[type="submit"][name="add"], [data-add-to-cart]') : null; }

    function writeButtonTotal() {
      var e = entry(); var b = button();
      if (!e || !b) return;
      var p = b.querySelector("[data-product-price]");
      if (!p) return;
      var total = e.mainPrice * qty() + (state.yes ? e.price : 0);
      p.textContent = money(total);
    }
    function render() {
      var e = entry();
      var show = !!(e && e.mainAvailable);
      root.hidden = !show;
      if (!show && state.yes) state.yes = false;
      yesBtn.setAttribute("aria-pressed", state.yes ? "true" : "false");
      noBtn.setAttribute("aria-pressed", state.yes ? "false" : "true");
      if (priceEl) priceEl.textContent = e ? " (+" + e.priceText + ")" : "";
      writeButtonTotal();
    }
    function later() { raf(render); }

    root.addEventListener("click", function (ev) {
      var t = ev.target.closest("[data-half-choice]");
      if (!t || !root.contains(t)) return;
      state.yes = t.getAttribute("data-half-choice") === "yes";
      render();
    });
    // the theme's quantity stepper fires a NON-bubbling change on the field and rewrites the button price, so
    // listen on the field itself and write our total on the next frame (same as door-configurator.js)
    function bindQty() {
      var f = qtyField();
      if (!f || f.__exosHalfQty) return;
      f.__exosHalfQty = true;
      f.addEventListener("change", later);
      f.addEventListener("input", later);
    }
    bindQty();
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () { bindQty(); later(); });
    }
    // safety net: any option change re-renders after the theme has swapped the button text
    scope.addEventListener("change", function () { setTimeout(render, 350); });

    document.addEventListener("submit", function (ev) {
      var f = ev.target;
      // getAttribute, not f.id: the form holds an input named "id" (the variant), which shadows the form's id property
      if (!f || !f.getAttribute || f.getAttribute("id") !== formId || !state.yes) return;
      var e = entry();
      if (!e || !e.mainAvailable) return; // no match: fall back to the normal add
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (state.busy) return;
      state.busy = true;

      var b = button();
      var textEl = b ? b.querySelector("[data-add-to-cart-text]") : null;
      if (b) { b.classList.add("is-loading"); b.setAttribute("disabled", "disabled"); }

      var props = {};
      var quantity = qty();
      try {
        new FormData(f).forEach(function (v, k) {
          var m = /^properties\[(.+)\]$/.exec(k);
          if (m && typeof v === "string" && v !== "") props[m[1]] = v;
          if (k === "quantity") { var n = parseInt(v, 10); if (n > 0) quantity = n; }
        });
      } catch (err) { /* keep defaults */ }
      var cfg = "door-stop-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
      props["_Door Main Item"] = "Yes";
      props["_Door Config ID"] = cfg;
      var items = [
        { id: Number(variantId()), quantity: quantity, properties: props },
        { id: e.id, quantity: 1, properties: { "_Door Add-On": "Yes", "_Door Config ID": cfg, "_Door Add-On Fixed Qty": "1" } }
      ];
      var url = ((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || "/cart/add").replace(/\.js$/, "") + ".js";

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          state.busy = false;
          if (res && res.status) {
            if (b) { b.classList.remove("is-loading"); b.removeAttribute("disabled"); }
            var pf = f.closest("product-form");
            if (pf && typeof pf.addToCartError === "function") { try { pf.addToCartError(res); } catch (err) { /* ignore */ } }
            return;
          }
          // back to No before the theme's "added" state captures the button text it restores later
          state.yes = false;
          render();
          document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("exos:cart:added", {
            bubbles: true,
            detail: { source: "door-stop-half", button: b, textEl: textEl, originalText: textEl ? textEl.innerHTML : "" }
          }));
        })
        .catch(function (err) {
          state.busy = false;
          if (b) { b.classList.remove("is-loading"); b.removeAttribute("disabled"); }
          if (window.console) console.log(err);
        });
    }, true);

    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll("[data-exos-half]"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
